import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

@Injectable()
export class PlanPackageService {
  private apiPrefix = '/admin/payment-plan-package';

  constructor(
    private api: ApiService,
  ) {
  }

  createPlanPackage(data: object) {
    return this.api.post(`${this.apiPrefix}`, data);
  }

  updatePlanPackage(id: number, data: object) {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  getPackages() {
    return this.api.get(`${this.apiPrefix}`);
  }
}
